import React, { useEffect, useState } from "react";
import Layout from "../Layouts/layout";
// import { Button, TextField } from "@mui/material";
// import Table from "@mui/material/Table";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import TableBody from "@mui/material/TableBody";
// import Paper from "@mui/material/Paper";
// import { Modal, ModalHeader, ModalBody } from "reactstrap";
// import { Stack } from "@mui/material";
// import { makeEncryptionData } from "../../../services/encryptionDecription.service";
import { decryptedData } from "../../../services/encryptionDecription.service";
import { fetchData, updateJsonData } from "../../../services/apiService";
import useAlertUtils from "../../../utils/common.utils";
import "./admins.scss";

function Admins() {
  // const [openModel, setOpenModel] = useState(false);
  // const [firstName, setFirstName] = useState("");
  // const [lastName, setLastName] = useState("");
  // const [email, setEmail] = useState("");
  // const { alertSuccess, alertError } = useAlertUtils();
  const [adminsData, setAdminsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingAction, setLoadingAction] = useState(null);
  const { alertSuccess, alertError } = useAlertUtils();
  const [activeTab, setActiveTab] = useState("pending");

  const getAdminsData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchData("/api/users/get-admins");
      setAdminsData(response.data);
    } catch (error) {
      alertError("Failed to load admin data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleApprove = async (adminId) => {
    setLoadingAction(adminId);
    try {
      const response = await updateJsonData(
        `/api/users/update-providerStatus/${adminId}`,
        {
          status: "Approved",
        }
      );
      if (response?.success) {
        alertSuccess("Admin approved successfully!");
        getAdminsData();
      } else {
        alertError(response?.message || "Failed to approve admin");
      }
    } catch (error) {
      alertError("An error occurred while approving admin");
    } finally {
      setLoadingAction(null);
    }
  };

  const handleReject = async (adminId) => {
    setLoadingAction(adminId);
    try {
      const response = await updateJsonData(
        `/api/users/update-providerStatus/${adminId}`,
        {
          status: "Rejected",
        }
      );
      if (response?.success) {
        alertSuccess("Admin rejected successfully!");
        getAdminsData();
      } else {
        alertError(response?.message || "Failed to reject admin");
      }
    } catch (error) {
      alertError("An error occurred while rejecting admin");
    } finally {
      setLoadingAction(null);
    }
  };

  // Filter admins by status
  const pendingAdmins =
    adminsData?.filter(
      (admin) =>
        admin.verifyStatus === 0 && admin.providerInfo?.status === "Pending"
    ) || [];
  const approvedAdmins =
    adminsData?.filter(
      (admin) =>
        admin.verifyStatus === 1 && admin.providerInfo?.status === "Approved"
    ) || [];
  const rejectedAdmins =
    adminsData?.filter(
      (admin) =>
        admin.verifyStatus === 0 && admin.providerInfo?.status === "Rejected"
    ) || [];

  // const toggleCatalog = () => setOpenModel(!openModel);

  // const handleCreateAdmin = () => {
  //   setOpenModel(true);
  // };

  // const closeModel = () => {
  //   setOpenModel(false);
  // };

  // const closeCatalogBtn = (
  //   <button className="btn closeEditBtn" onClick={toggleCatalog} type="button">
  //     &times;
  //   </button>
  // );

  // const generateRandomPassword = () => {
  //   const characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   let password = "";
  //   for (let i = 0; i < 8; i++) {
  //     const randomIndex = Math.floor(Math.random() * characters.length);
  //     password += characters[randomIndex];
  //   }
  //   return password;
  // };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const adminData = {
  //     firstName,
  //     lastName,
  //     email,
  //     password: generateRandomPassword(),
  //   };

  //   try {
  //     const encryptedData = makeEncryptionData(adminData);
  //     encryptedData.role = 1;
  //     encryptedData.agreeTerms = 1;

  //     if (encryptedData) {
  //       const response = await SubmitData(
  //         "/api/users/register-admin",
  //         encryptedData
  //       );
  //       if (response?.success) {
  //         alertSuccess(
  //           "A verification email has been sent to Admin's registered email"
  //         );
  //         setFirstName("");
  //         setLastName("");
  //         setEmail("");
  //         closeModel();
  //         getAdminsData();
  //       } else {
  //         alertError(response?.message);
  //       }
  //     }
  //   } catch (error) {
  //     alertError(
  //       "An error occurred while Admin's Registeration. Please try again."
  //     );
  //   }
  // };

  useEffect(() => {
    getAdminsData();
  }, []);

  return (
    <>
      <Layout>
        <div className="main_content">
          <div className="container">
            <div className="main_block">
              <div className="top_bar">
                <div className="left_part">
                  <div className="main_title">Admins</div>
                </div>
                {/* <div className="right_part">
                  <div className="right_part_inner">
                    <button
                      onClick={handleCreateAdmin}
                      className="btn btn-primary add_kit"
                    >
                      Create Admin
                    </button>
                  </div>
                </div> */}
              </div>
              {isLoading ? (
                <div className="loading-container">
                  <div className="loading-spinner"></div>
                  <p>Loading admin data...</p>
                </div>
              ) : (
                <div className="admins-sections">
                  <div className="admins-tabs">
                    {[
                      { key: "pending", label: "Pending" },
                      { key: "approved", label: "Approved" },
                      { key: "rejected", label: "Rejected" },
                    ].map((t) => (
                      <button
                        key={t.key}
                        type="button"
                        onClick={() => setActiveTab(t.key)}
                        style={{
                          padding: "8px 16px",
                          borderRadius: 999,
                          border:
                            activeTab === t.key
                              ? "1px solid #f43f5e"
                              : "1px solid #fbcfe8",
                          background:
                            activeTab === t.key
                              ? "linear-gradient(90deg, #f43f5e 0%, #fb7185 100%)"
                              : "#ffffff",
                          color: activeTab === t.key ? "#fff" : "#881337",
                          fontWeight: 700,
                          cursor: "pointer",
                          fontSize: 14,
                          boxShadow:
                            activeTab === t.key
                              ? "0 3px 10px rgba(244,63,94,0.25)"
                              : "0 1px 2px rgba(0,0,0,0.05)",
                          transition: "all .25s ease",
                        }}
                      >
                        {t.label}
                      </button>
                    ))}
                  </div>

                  {activeTab === "pending" && (
                  <div className="admin-section">
                    <h3 className="section-title mb-3">
                      Pending Approval ({pendingAdmins.length})
                    </h3>
                    <div className="admins-table-wrapper">
                      <table className="admins-table is-pending">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Organization</th>
                            <th>NPI Number</th>
                            <th>License Number</th>
                            <th>License State</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pendingAdmins.map((admin) => (
                            <tr key={admin.id}>
                              <td>
                                {decryptedData(admin.firstName)}{" "}
                                {decryptedData(admin.lastName)}
                              </td>
                              <td>{decryptedData(admin.email)}</td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.organizationName
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(admin.providerInfo.NPI_number)
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.licenseNumber
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.licenseState
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(admin.providerInfo.phoneNo)
                                  : "-"}
                              </td>
                              <td>
                                <span
                                  className={`status-badge ${(
                                    admin.providerInfo?.status || "Pending"
                                  ).toLowerCase()}`}
                                >
                                  {admin.providerInfo?.status || "Pending"}
                                </span>
                              </td>
                              <td>
                                <div className="admin-actions">
                                  <button
                                    className="btn-approve"
                                    onClick={() => handleApprove(admin.id)}
                                    disabled={loadingAction === admin.id}
                                  >
                                    {loadingAction === admin.id ? (
                                      <>
                                        <div className="button-spinner"></div>
                                        Processing...
                                      </>
                                    ) : (
                                      "Approve"
                                    )}
                                  </button>
                                  <button
                                    className="btn-reject"
                                    onClick={() => handleReject(admin.id)}
                                    disabled={loadingAction === admin.id}
                                  >
                                    {loadingAction === admin.id ? (
                                      <>
                                        <div className="button-spinner"></div>
                                        Processing...
                                      </>
                                    ) : (
                                      "Reject"
                                    )}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {pendingAdmins.length === 0 && (
                            <tr>
                              <td colSpan={9}>
                                <div className="no-records">
                                  No pending admins
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  )}

                  {activeTab === "approved" && (
                  <div className="admin-section mt-5">
                    <h3 className="section-title mb-3">
                      Approved ({approvedAdmins.length})
                    </h3>
                    <div className="admins-table-wrapper">
                      <table className="admins-table is-approved">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Organization</th>
                            <th>NPI Number</th>
                            <th>License Number</th>
                            <th>License State</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {approvedAdmins.map((admin) => (
                            <tr key={admin.id}>
                              <td>
                                {decryptedData(admin.firstName)}{" "}
                                {decryptedData(admin.lastName)}
                              </td>
                              <td>{decryptedData(admin.email)}</td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.organizationName
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(admin.providerInfo.NPI_number)
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.licenseNumber
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.licenseState
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(admin.providerInfo.phoneNo)
                                  : "-"}
                              </td>
                              <td>
                                <span
                                  className={`status-badge ${(
                                    admin.providerInfo?.status || "Approved"
                                  ).toLowerCase()}`}
                                >
                                  {admin.providerInfo?.status || "Approved"}
                                </span>
                              </td>
                              <td>-</td>
                            </tr>
                          ))}
                          {approvedAdmins.length === 0 && (
                            <tr>
                              <td colSpan={9}>
                                <div className="no-records">
                                  No approved admins
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  )}

                  {activeTab === "rejected" && (
                  <div className="admin-section mt-5">
                    <h3 className="section-title mb-3">
                      Rejected ({rejectedAdmins.length})
                    </h3>
                    <div className="admins-table-wrapper">
                      <table className="admins-table is-rejected">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Organization</th>
                            <th>NPI Number</th>
                            <th>License Number</th>
                            <th>License State</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rejectedAdmins.map((admin) => (
                            <tr key={admin.id}>
                              <td>
                                {decryptedData(admin.firstName)}{" "}
                                {decryptedData(admin.lastName)}
                              </td>
                              <td>{decryptedData(admin.email)}</td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.organizationName
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(admin.providerInfo.NPI_number)
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.licenseNumber
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(
                                      admin.providerInfo.licenseState
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {admin.providerInfo
                                  ? decryptedData(admin.providerInfo.phoneNo)
                                  : "-"}
                              </td>
                              <td>
                                <span
                                  className={`status-badge ${(
                                    admin.providerInfo?.status || "Rejected"
                                  ).toLowerCase()}`}
                                >
                                  {admin.providerInfo?.status || "Rejected"}
                                </span>
                              </td>
                              <td>
                                <div className="admin-actions">
                                  <button
                                    className="btn-approve"
                                    onClick={() => handleApprove(admin.id)}
                                    disabled={loadingAction === admin.id}
                                  >
                                    {loadingAction === admin.id ? (
                                      <>
                                        <div className="button-spinner"></div>
                                        Processing...
                                      </>
                                    ) : (
                                      "Accept"
                                    )}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {rejectedAdmins.length === 0 && (
                            <tr>
                              <td colSpan={9}>
                                <div className="no-records">
                                  No rejected admins
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
      {/* <Modal size="lg" isOpen={openModel} backdrop="static" toggle={closeModel}>
        <ModalHeader
          style={{ display: "flex", justifyContent: "space-between" }}
          toggle={toggleCatalog}
          close={closeCatalogBtn}
        >
          Create Provider
        </ModalHeader>

        <ModalBody>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="First Name"
                variant="outlined"
                fullWidth
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <TextField
                label="Last Name"
                variant="outlined"
                fullWidth
                required
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <TextField
                label="Email"
                variant="outlined"
                type="email"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                type="submit"
                variant="contained"
                color="error"
                size="large"
              >
                Create Provider
              </Button>
            </Stack>
          </form>
        </ModalBody>
      </Modal> */}
    </>
  );
}

export default Admins;
